import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { StyleSheet, View, Text, Image, Dimensions, Platform, StatusBar } from 'react-native';
import { Button, Text as TextNB } from 'native-base';
import * as Updates from 'expo-updates';
import { LinearGradient } from 'expo-linear-gradient';
//import { createIconSetFromIcoMoon } from 'react-native-vector-icons';
//import icoMoonConfig from '../../../../assets/fonts/selection.json';
//const AntSVGs = createIconSetFromIcoMoon(icoMoonConfig, 'icomoon');
import AppIntroSlider from 'react-native-app-intro-slider';

const organize = require('../../../assets/organize.png');
const share = require('../../../assets/share.png');
const report = require('../../../assets/report.png');
const sync = require('../../../assets/cloudsync.png');

const windowsWidth = Dimensions.get('window').width;
const windowsHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
	mainContent: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'space-around',
		paddingBottom: 70
	},
	image: {
		width: 320,
		height: 320
	},
	text: {
		color: 'rgba(255, 255, 255, 0.8)',
		backgroundColor: 'transparent',
		textAlign: 'center',
		paddingHorizontal: 16
	},
	title: {
		fontSize: 22,
		color: 'white',
		backgroundColor: 'transparent',
		textAlign: 'center',
		marginBottom: 16
	},
	demoButtonView: { position: 'absolute', top: 10, width: '100%' }
});

const slides = [
	{
		key: 'somethun',
		title: 'Quick setup, tailored for your business',
		pic: organize,
		text: 'Our unique calendar lets you see your transactions all in one place - income, expenses and assets',
		icon: 'md-calendar',
		colors: ['#438eb9', '#252932']
	},
	{
		key: 'somethun1',
		title: 'Customers and Invoicing',
		pic: share,
		text: 'Send invoices straight from your mobile - share via Whatsapp, Messenger or email; or email from CalCal.',
		icon: 'ios-person-add',
		colors: ['#A3A1FF', '#3A3897']
	},
	{
		key: 'somethun2',
		title: 'See your basic reports and tax',
		pic: report,
		text: 'And best of all it is free',
		icon: 'ios-trending-up',
		colors: ['#29ABE2', '#4F00BC']
	},
	{
		key: 'somethun3',
		title: 'Synced between devices and the web',
		pic: sync,
		text: "All your data is safely stored in the cloud, so you can access it anywhere and you don't have to worry about losing it.",
		icon: 'ios-trending-up',
		colors: ['#252932', '#438eb9']
	}
];

export default class App extends React.Component {
	state = { slide: 0 };

	_renderItem = props => {
		//console.log(props);
		return (
			<LinearGradient
				style={[
					styles.mainContent,
					{
						width: windowsWidth,
						paddingTop: props.topSpacer
					}
				]}
				colors={props.item.colors}
				start={{ x: 0, y: 0.1 }}
				end={{ x: 0.1, y: 1 }}>
				<Image source={props.item.pic} style={{ backgroundColor: 'transparent', height: 200, width: '100%', resizeMode: 'contain', alignSelf: 'center' }} />

				<View style={{ paddingBottom: 35 }}>
					<Text style={styles.title}>{props.item.title}</Text>
					<Text style={styles.text}>{props.item.text}</Text>
				</View>
			</LinearGradient>
		);
	};

	_renderNextButton = () => {
		return (
			<View style={{ margin: 30 }}>
				<Ionicons name="md-arrow-round-forward" color="rgba(255, 255, 255, .9)" size={24} style={{ backgroundColor: 'transparent' }} />
			</View>
		);
	};
	_renderDoneButton = () => {
		return <View />;
	};

	_onDone = () => {
		console.log('done');
		this.props.navigation.navigate('Login');
	};

	_signUp = () => {
		console.log('sign-up');
		this.props.navigation.navigate('SignUpContainer');
	};

	_demo = () => {
		console.log('sign-up');
		this.props.navigation.navigate('DemoSelect');
	};

	render() {
		const { taxOnly } = this.props;
		if (Platform.OS == 'web') return <View style={{ flex: 1, backgroundColor: '#6aa4c8' }} />;

		return (
			<View style={{ flex: 1 }}>
				{false && <StatusBar hidden backgroundColor="transparent" bob={slides[this.state.slide].colors[0]} />}
				<AppIntroSlider
					style={{ flex: 1 }}
					data={slides}
					renderItem={this._renderItem}
					renderNextButton={this._renderNextButton}
					renderDoneButton={this._renderDoneButton}
					onDone={this._onDone}
					onSlideChange={i => this.setState({ slide: i })}
				/>

				<View style={styles.demoButtonView}>
					<Button light bordered style={{ width: 200, margin: 20, justifyContent: 'center', alignSelf: 'center' }} onPress={this._demo}>
						<TextNB>Try a Demo</TextNB>
					</Button>
				</View>

				<View style={{ flexDirection: 'row', position: 'absolute', bottom: 70, width: '100%', justifyContent: 'center' }}>
					<Button light bordered style={{ width: 100, margin: 20, justifyContent: 'center' }} onPress={this._onDone}>
						<TextNB>Log In</TextNB>
					</Button>
					<Button light bordered style={{ width: 100, margin: 20, justifyContent: 'center' }} onPress={this._signUp}>
						<TextNB>Sign Up</TextNB>
					</Button>
				</View>
			</View>
		);
	}
}
